import { AdjudicationResult } from '@core/model';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { SubSink } from 'subsink';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DateUtilities, SessionStorageService, TableColumn } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-negotiation-cummulative',
    templateUrl: './negotiation-cummulative.component.html',
    styleUrls: ['./negotiation-cummulative.component.scss'],
    standalone: false
})
export class NegotiationCummulativeComponent implements OnInit, OnDestroy {
  @Output() adjudicationChanged = new EventEmitter<AdjudicationResult>();
  @Output() submitNegotiationCumulative = new EventEmitter<boolean>();
  @Input() adjudication: AdjudicationResult;


  isVisible = true;
  totalAllowedVisitsExceeded = false;
  subs = new SubSink();
  negotiationCummulativeEditForm1: FormGroup;
  newrequestedAmountOutofRange = false;
  interval: any;
  remainingTime: any;
  formattedTime: any;

  columns: Array<TableColumn> = [
      new TableColumn('Skill', 'skillCode', '5rem'),
      new TableColumn('Effective From', 'effectiveFromDate', '10rem'),
      new TableColumn('Effective To', 'effectiveToDate', '10rem'),
      new TableColumn('Requested', 'requestedAmount', '8rem'),
      new TableColumn('New Requested', 'newAmount', '10rem'),
      new TableColumn('Maximum Allowed', 'skillCapAmount', '7rem'),
    ];

  constructor(
    private sessionStorageService: SessionStorageService,
  ) {
  }
  ngOnInit() {
    window.addEventListener('beforeunload', (event) => {
      if(this.adjudication.isNegotiationNeeded){
        this.handleSendFormManualReview();
      }
    });
    this.negotiationCummulativeEditForm();
    this.showNegotiationScreen();
  }

  negotiationCummulativeEditForm() {
    this.negotiationCummulativeEditForm1 = new FormGroup({
      requestedAmount: new FormArray([])
    });

    this.addRequestedAmountControl();
    this.requestedAmountWatch();
  }

  addRequestedAmountControl() {
    let totalAmount = 0;

    this.adjudication.negotiations.forEach(negotiation => {
      this.requestedAmount.push(
        new FormGroup({
          newAmount: new FormControl(negotiation.newRequestedAmount,
            [Validators.required, Validators.min(1), Validators.max(negotiation.skillCapAmount || 99)]
          )
        })
      );
      totalAmount += negotiation.newRequestedAmount;
    });

    this.checkTotalVisits(totalAmount);
  }

  requestedAmountWatch() {
    this.requestedAmount.valueChanges.subscribe(res => {
      let totalAmount = 0;

      res.forEach(amount => {
        totalAmount += amount.newAmount;
      });
      this.checkTotalVisits(totalAmount);
    });
  }

  checkTotalVisits(totalAmount: number) {
    this.totalAllowedVisitsExceeded = totalAmount > this.adjudication.cumulativeCap;
  }

  get requestedAmount(): FormArray {
    return this.negotiationCummulativeEditForm1.get('requestedAmount') as FormArray;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    window.removeEventListener('beforeunload', (event) => {
      if(this.adjudication.isNegotiationNeeded){
        this.handleSendFormManualReview();
      }
    });
  }

  fillNegotiation() {
    if (this.adjudication.negotiations) {
      this.adjudication.negotiations.forEach((negotiation, index) => {
        negotiation.newRequestedAmount = this.requestedAmount.controls[index].value.newAmount;
        negotiation.acceptOrReject = 'Accept';
      });
    }
  }

  handleSendFormManualReview() {
    this.adjudication.isSentForReview = true;
    this.adjudication.isReprocessed = false;
    // null out NewRequestedAmount since user wants Manual Review
    this.adjudication.negotiations.forEach(e => e.newRequestedAmount = null);
    this.adjudicationChanged.emit(this.adjudication);
    this.handleNegotiationCompleted();
  }

  handleReprocessForAutoApproval() {
    this.adjudication.isSentForReview = false;
    this.adjudication.isReprocessed = true;
    this.fillNegotiation();
    this.adjudicationChanged.emit(this.adjudication);
    this.handleNegotiationCompleted();
  }

  handleNegotiationCompleted() {
    this.submitNegotiationCumulative.emit(true);
  }

  showNegotiationScreen() {
    const submitRequestTime = DateUtilities.convertUtcToLocal(this.adjudication.negotiations[0]?.createdOn);
    const currentTime = new Date();
    // Calculate the difference in minutes
    const differenceInMilliseconds = currentTime.getTime() - submitRequestTime.getTime();
    const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

    if (differenceInMinutes < 30) {
      this.startCountdownTimer(30); // Start a 30-minute countdown timer
    }
    else{
      this.handleSendFormManualReview();
    }

  }


  private startCountdownTimer(minutes: number) {
    this.remainingTime = minutes * 60; // Convert minutes to seconds
    this.updateTimer();
    this.interval = setInterval(() => {
      this.remainingTime--;
      this.updateTimer();
      if (this.remainingTime <= 0) {
        clearInterval(this.interval);
        this.formattedTime = '00:00';
        this.handleSendFormManualReview();
      }
    }, 1000);
  }


  private updateTimer() {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = this.remainingTime % 60;
    this.formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
